import { OrderType } from "../utils/orderTypeUtils";
import { Address } from "@wagmi/core";
import Decimal from "decimal.js";
import { Token } from "../store/global/TokenEnum";
import { Amount } from "./amount";

export interface TradeHistoryData {
  results: Record<TransactionDetail["txHash"], TransactionDetail>;
  nextAvailableTimestamp: number | null;
}

export interface TradeHistoryDataRaw {
  results: Array<TransactionDetailRaw>;
  nextAvailableTimestamp: number | null;
}

export enum TRANSACTION_STATUSES {
  "SETTLED" = "SETTLED",
  "REVERTED" = "REVERTED",
}

export interface BoughtOrSoldFields {
  address: string;
  amount: Amount;
  amountUsd: Decimal;
}
export interface BoughtOrSoldFieldsRaw {
  address: string;
  amount: bigint;
  amountUsd: Decimal;
}

export type TokenHistoryInfo = {
  [key in Token]?: BoughtOrSoldFields;
};
export type TokenHistoryInfoResponse = {
  [key in Token]?: BoughtOrSoldFieldsRaw;
};

export interface TransactionDetail {
  chain_id: number;
  status: TRANSACTION_STATUSES;
  type: OrderType;
  sender: Address;
  receiver: Address;
  sellTokens: TokenHistoryInfo;
  buyTokens: TokenHistoryInfo;
  timestamp: Date;
  volumeUsd: Amount;
  gasFeeUsd: number;
  txHash: string;
}

export interface TransactionDetailRaw {
  chain_id: number;
  status: TRANSACTION_STATUSES;
  type: OrderType;
  sender: Address;
  receiver: Address;
  sellTokens: TokenHistoryInfoResponse;
  buyTokens: TokenHistoryInfoResponse;
  timestamp: string;
  volumeUsd: number;
  gasFeeUsd: number;
  txHash: string;
}
